
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as authLldLAL6sjaJfinhufTblQ2SvXbV4tXp__siTwYISsSIMeta } from "/app/pages/auth.vue?macro=true";
import { default as indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta } from "/app/pages/index.vue?macro=true";
import { default as rulesoW3OsXfUxMGzTjcJPfE4v0oEYZyNpAmFSWz4Vk42uNYMeta } from "/app/pages/rules.vue?macro=true";
import { default as offlineb6lZOoB1oWgiyEh5BqfDjL_451628CgKDJDLM01ZD4z_45kMeta } from "/app/pages/offline.vue?macro=true";
import { default as about_45usWFQXpt2DA4_34Qah2UTFFyJ33ypdDo2QsAhRa5cVZQUMeta } from "/app/pages/about-us.vue?macro=true";
import { default as indexXDrvC4X9cQh98rUTaKV7n9SAzKfJcTLnbJGv9g_YdesMeta } from "/app/pages/blog/index.vue?macro=true";
import { default as contact_45usyd4g5JQzXkDqfbBMnZj_451ycedSGcW8_45awFheztbRsmwMeta } from "/app/pages/contact-us.vue?macro=true";
import { default as index8_45YXU8kv2TXBFC5ALhjrDlmO3DYA1F8Es3FcDO0F6iMMeta } from "/app/pages/help/index.vue?macro=true";
import { default as indexUTPWuOuTEHiifiH2gSDbviVYzY2wHbmPaccb9r89Io4Meta } from "/app/pages/admin/index.vue?macro=true";
import { default as loginORwvU__450lx7h_a9Mz6vtkVrJAAfhRAYGj98sVs_awdkMeta } from "/app/pages/admin/login.vue?macro=true";
import { default as inbox3fFI0WS94j8rfUz5TQMhMEEmudPzZQkpZH4I9B2vbtsMeta } from "/app/pages/company/inbox.vue?macro=true";
import { default as indexJtiR2iUJYsVgaMe_458fDwmvRX6y7wUgu7tvkBlbEbH60Meta } from "/app/pages/company/index.vue?macro=true";
import { default as settingsg2zX8nioCwTJTQJ7pqLYHIJFkG2HuHXAH2jmbz4Bn6cMeta } from "/app/pages/panel/settings.vue?macro=true";
import { default as indexA0ipq3NF43kxgxYew2okNjPLJ3zj9gkf6Om8fCaqMQEMeta } from "/app/pages/panel/cms/index.vue?macro=true";
import { default as indexKACDXg6o6F74V0ouZRPFTV0XcPrzJtG2bPL7mJzhW4cMeta } from "/app/pages/panel/crm/index.vue?macro=true";
import { default as dashboard0KsEE031eoVi9uvuA2zHYhJPRuRRTCLTYitSy0LKn8MMeta } from "/app/pages/panel/dashboard.vue?macro=true";
import { default as indexZD1zB2EhA0eQG8RqBK93SYf_45EeOCH8SfVvtxUxTh5ZwMeta } from "/app/pages/admin/logs/index.vue?macro=true";
import { default as _91page_93tWVLQxj_45IwiGSTGYtF0VCG3t_lb_NjUUfgGHUCVBtbIMeta } from "/app/pages/blog/page/[page].vue?macro=true";
import { default as settings02wNYz9kiIAaBCxissohSZMvpWx3GvmSeGrTvsVGOU0Meta } from "/app/pages/company/settings.vue?macro=true";
import { default as _91page_93__mLic9JBDCdPH2jOphzimY567HHSqoKSXBhupplmDsMeta } from "/app/pages/help/page/[page].vue?macro=true";
import { default as indexqNUqQ__45PxIzfT3AB03w4MX3rHCi7kq6KghCUZn6fCMMMeta } from "/app/pages/panel/chat/index.vue?macro=true";
import { default as index_45Td_WANauL3bPMiW6WgL_QnV9ipZUmsmKgjoIPe4EVoMeta } from "/app/pages/panel/vira/index.vue?macro=true";
import { default as indexkCBDnrxIenNG8eh8enz_45uDA1MAYpaXPDx8fjLGQNjc8Meta } from "/app/pages/admin/metas/index.vue?macro=true";
import { default as indexltxI97WNHsMr63oX2u0o4A_OAM3WsdBsdjIqZrdzH4kMeta } from "/app/pages/admin/posts/index.vue?macro=true";
import { default as index95T7fNWKvpE2_45lRAkfp73ooTvEoS11P2m5npL9Oelo0Meta } from "/app/pages/admin/rules/index.vue?macro=true";
import { default as indexgvs7WdV1NLBsiIM1p5V4txUPTMYikQ1vfsYYESmgxtgMeta } from "/app/pages/admin/users/index.vue?macro=true";
import { default as indexfWC5IFqS0N5ikXxI8m85tv8wtXayhLmb1z89nx3vcC4Meta } from "/app/pages/panel/mails/index.vue?macro=true";
import { default as indexbr2vWuPqyIfzRBNBZJJMkaXJ4Uxu4eX7z1Nnx0ad_SAMeta } from "/app/pages/panel/roles/index.vue?macro=true";
import { default as indexIcIdIbe8OtqM4xTyDf7u8epIx1maMvZwQaRjXkHXXlQMeta } from "/app/pages/panel/users/index.vue?macro=true";
import { default as create5N_iNwVdmfryvM7anBa_45kH55LeUfUex91gEis7hyV_kMeta } from "/app/pages/admin/posts/create.vue?macro=true";
import { default as indexeXXIuEL_6gfEHVhxkiIRn95_45lbPomXRymRi0qFCcKl8Meta } from "/app/pages/admin/slides/index.vue?macro=true";
import { default as indexrhrdOOheMWOk5Gh9VybN9OLHIr3RRU2k9zNCDTrGPVUMeta } from "/app/pages/company/chat/index.vue?macro=true";
import { default as indexrk0MJ0gY5l77Utsd9qr431bBGm5map8WCJ3VS08WGsoMeta } from "/app/pages/company/mails/index.vue?macro=true";
import { default as indexo_45ZsZPEsvC83BOtt7mjDDMBDDKjmM1qxtbLRVkCXUrUMeta } from "/app/pages/company/tasks/index.vue?macro=true";
import { default as indexCV5tsnrOHJqviFsvkIkg0KlHXpg_i3u0UFLRiYIPYvwMeta } from "/app/pages/panel/careers/index.vue?macro=true";
import { default as dashboardXKIrv4sYhsHVtsx07OvV4hbh7VVgNNKlqip_g3GrAugMeta } from "/app/pages/panel/cms/dashboard.vue?macro=true";
import { default as foodsjmgjEbUq6rNUlGMftklTQrlfqE5qr2OruvhLJniIeFMMeta } from "/app/pages/panel/kitchen/foods.vue?macro=true";
import { default as indexFEQLGwHyfNnMdYf5Q_lOECqETePqTtyaI6IhVusdOlAMeta } from "/app/pages/panel/kitchen/index.vue?macro=true";
import { default as indexAcRiYnv_JNG6NFHxeyMK_45ecY1XfTcul4kAa06_xg2hgMeta } from "/app/pages/panel/surveys/index.vue?macro=true";
import { default as indexzs06hQjpSe09qjcJyGy6y9ZUBDJ9byod_KUSbsLFoJkMeta } from "/app/pages/admin/about-us/index.vue?macro=true";
import { default as _91postId_93f7aSoFY3PN1nXzVGsHEAXBgidMlwQG5moi99Sz_459QEIMeta } from "/app/pages/admin/posts/[postId].vue?macro=true";
import { default as _91postId_93agg3RKsbzHy40z4MJeKdt4sh8k9AVCii0NioWZz0lzoMeta } from "/app/pages/help/single/[postId].vue?macro=true";
import { default as indexsFKR7GwacwEAbhOKn_45ffm4myYzI3sKOvIc874uIOOx0Meta } from "/app/pages/panel/contacts/index.vue?macro=true";
import { default as _91noteId_93X0G7aY1MwnpCTxJWRYoqWoCu2qa6wUw2uzUJJOb_45zGAMeta } from "/app/pages/panel/mails/[noteId].vue?macro=true";
import { default as indexiZNQuvs2RIoyYHigxJ9e_TGVKqfzh_45ulumMV53sWfL8Meta } from "/app/pages/panel/projects/index.vue?macro=true";
import { default as _91userId_93GxftT9hOFwN_45dJCaiUZf9Q6cdiXu_d5Jj1NOoPozYn8Meta } from "/app/pages/panel/users/[userId].vue?macro=true";
import { default as index6H7j_45ISlWXzKlP6HjyTpIjKJpglJHRsvO_45bVj973aNAMeta } from "/app/pages/admin/companies/index.vue?macro=true";
import { default as index23qrxlhPZZFISW0nXMVsr4gnBC7auAMAugMCSQUDKzwMeta } from "/app/pages/company/surveys/index.vue?macro=true";
import { default as indexG8QBNqORZOkPUOOJCpxXrVhXLG3SEFTZn_76vvCTLa4Meta } from "/app/pages/panel/cms/forms/index.vue?macro=true";
import { default as indexR398wZglvZF5auaEDdIB_2n5QdHwfmCJ4pGkOAgFRjsMeta } from "/app/pages/admin/categories/index.vue?macro=true";
import { default as index3nUKxJDyJZ6PkrwnBsVy1utVPz2rcsDYqQmj8M457fgMeta } from "/app/pages/admin/contact-us/index.vue?macro=true";
import { default as _91page_932AwH4dp1yyyCdBqH6I86C4GAt3gWfaph1sVod8sZptsMeta } from "/app/pages/admin/logs/page/[page].vue?macro=true";
import { default as _91noteId_93qHcywCjHZfGgS7IDA0IlbW9AMjkKxkW_VojTgqa_45deEMeta } from "/app/pages/company/mails/[noteId].vue?macro=true";
import { default as indexAn_45RuILv0dcvpHccYr_45jRCZJ9plnVIWIUvmoe7rveMoMeta } from "/app/pages/company/projects/index.vue?macro=true";
import { default as indexPdPNKMsCAwtat60zZ27BBEbCJQHa6s8zjfjVwS_skvQMeta } from "/app/pages/panel/categories/index.vue?macro=true";
import { default as createtr6YWRZyEC9IrRLO0Wk3_45vR84b_45qe093T2rDyPE065YMeta } from "/app/pages/panel/cms/posts/create.vue?macro=true";
import { default as company_45settingsfUn8_45Sc3OAyANoKA_45HM9mdwY0x1rVWU2Uit23_oZ6wcMeta } from "/app/pages/panel/company-settings.vue?macro=true";
import { default as dashboardRwOsEl0viFsiAIxllpGaZnxjl9V_45Cd_45tXrR7HwQpZRkMeta } from "/app/pages/panel/people/dashboard.vue?macro=true";
import { default as index5tiPbTPTKYS_45nSbM3m8PedXBAg8jMh1NqRtv18c6wOQMeta } from "/app/pages/admin/dev-tickets/index.vue?macro=true";
import { default as _91page_93VYCIGl_jpU35KoG0sO0DtYGQ3Jby6Z_2zCMFQaWavxYMeta } from "/app/pages/admin/posts/page/[page].vue?macro=true";
import { default as _91page_934T6t_45JjKABG4iMGEu8kG1x52TgiYSCa1XyO0Kt1YCTUMeta } from "/app/pages/admin/users/page/[page].vue?macro=true";
import { default as _91articleId_93fUu_45d8_45Xr1z3jVVhp_45nN7_45IvHfLfY4MpN1MAVAiIw4EMeta } from "/app/pages/blog/single/[articleId].vue?macro=true";
import { default as indexi7MOjb_Xh_ZujDIpivnOkOQ7tXTklvgDOc2Ew8Te_kIMeta } from "/app/pages/panel/attendances/index.vue?macro=true";
import { default as indexxLTYQ_qK_TxfIEZGR7rRQNQj00uBUR8Rko0MW23ZM7AMeta } from "/app/pages/panel/dev-tickets/index.vue?macro=true";
import { default as _91page_93CSx4ESJ2pbdxyJgCH21bVcT9TZbI3QEAJT5e7x_459VEgMeta } from "/app/pages/panel/mails/page/[page].vue?macro=true";
import { default as _91page_93PJDBDTAQBESkfRzEXNTQfYfFOTpVXXyyX7B0_45eSgVScMeta } from "/app/pages/panel/users/page/[page].vue?macro=true";
import { default as authhk_45ok15NdCFoNWIrug0_GhOtZfSsQdsoPGFkMdaodPUMeta } from "/app/pages/company/[companyId]/auth.vue?macro=true";
import { default as categories4h_45vroEW9mI00_BDdCyMoZ95t4Uek_AHfOIi_452BO6fAMeta } from "/app/pages/panel/careers/categories.vue?macro=true";
import { default as _91formId_93KloYZOdgMCIGtmwnIdOlJt2_woS3IyZy_q3weg5wBeoMeta } from "/app/pages/panel/cms/forms/[formId].vue?macro=true";
import { default as _91postId_93uTeYQs6uscJQlcsk9caNRwQlanarbfZapFbW9fAKQeoMeta } from "/app/pages/panel/cms/posts/[postId].vue?macro=true";
import { default as index4tN93a9A_45Cp2ABo9Hxj0eQpdCHQIKspWntTKjsUiJ14Meta } from "/app/pages/panel/custom-pages/index.vue?macro=true";
import { default as organization_45chartbz9gP24IWEcNBATqXJWfvp5z97_VGTK2IehhBPkDjlMMeta } from "/app/pages/panel/organization-chart.vue?macro=true";
import { default as organization_45unitsMbkXJ7NaE67sfdGyq9ilVuvlCI9K1I0FGhSusHShoLQMeta } from "/app/pages/panel/organization-units.vue?macro=true";
import { default as dashboard4jtVKAFilM6_2V12RLwHZWasuoAUsmdfJO5gJdOFZP0Meta } from "/app/pages/panel/payrolls/dashboard.vue?macro=true";
import { default as _91surveyId_93TZ72T7FeIcllWZlP3l_pkXxr1_45fgKSyc1zYxPfRhvsgMeta } from "/app/pages/panel/surveys/[surveyId].vue?macro=true";
import { default as indexW6ga2ORPRt_45Tnyg_itkJ0ZRXn04qsL3Rr5zNvbVLtgMMeta } from "/app/pages/company/attendances/index.vue?macro=true";
import { default as _91page_93qXuORRbi19uUVxa6CPRxzcD1kcSH3oYVlm1tsNfbnnYMeta } from "/app/pages/company/mails/page/[page].vue?macro=true";
import { default as _91page_93Pt8OUbHK12Q5A_45uvmiEKwgUMI7pVn04c22PN7l7mrqQMeta } from "/app/pages/company/tasks/page/[page].vue?macro=true";
import { default as index_ocwmE8VQUNbCt1jpGhPFcu_45JhwnpSI6dRBxDASZYNgMeta } from "/app/pages/panel/announcements/index.vue?macro=true";
import { default as indextXln13DDQvo1rz73YCyEbYuiwES1iG60i_45dU_edOHOMMeta } from "/app/pages/panel/benefit-funds/index.vue?macro=true";
import { default as loansFWUScQe7xd0uiG3hH9pRNvlxmrHhPjmxjoLecgB_p1UMeta } from "/app/pages/panel/benefit-funds/loans.vue?macro=true";
import { default as activitiescxKbjnIj7aVGIBuV6Ohn_45zMgwMiBfQvqqnqLKobNBjMMeta } from "/app/pages/panel/projects/activities.vue?macro=true";
import { default as _91page_93kWuVggs1zAj8T6_45SnqewkR1EdObwMH0O3sa54uyZWhQMeta } from "/app/pages/panel/surveys/page/[page].vue?macro=true";
import { default as dashboardBGTgXv3A8J6emu5sADm1Qk1bVWIXoSWDmYKMovpcZE0Meta } from "/app/pages/panel/workspace/dashboard.vue?macro=true";
import { default as dashboardbQVmAv94vWp_U8JhnSXNqfoOe9j9lM0V__45rjLD4RKz4Meta } from "/app/pages/company/payrolls/dashboard.vue?macro=true";
import { default as indexrvghCfJBYCgDz0eTnxKTA_45e3jHLA88YKhypAIYx7SyIMeta } from "/app/pages/company/reserve-food/index.vue?macro=true";
import { default as overviewWZJTBIDomzoFr7hD_45_PwhsIR4Lz6JrJxjzdo3wpHaDQMeta } from "/app/pages/company/workspace/overview.vue?macro=true";
import { default as _91userId_93Wsl8x6edHOXwFYrSfixGoT0GWn_45bO2NIvpQHdN6EFskMeta } from "/app/pages/panel/attendances/[userId].vue?macro=true";
import { default as _91page_93Kt5G3qbdoKG_qClsQj0FdpfmQHbwKoDdYuca3ZsGA6cMeta } from "/app/pages/panel/contacts/page/[page].vue?macro=true";
import { default as _91page_93ntaRJVOuAMPD6PDe0aLvN7EYPI4A5BL2dmysR7iKJHQMeta } from "/app/pages/panel/projects/page/[page].vue?macro=true";
import { default as _91page_93Rj7DhpfLjzGaw2SGgqsTkaZDKdI6lHHo1QsRm8bn_45n0Meta } from "/app/pages/admin/companies/page/[page].vue?macro=true";
import { default as indexpYQallPLiS0cXN6nCy_v_iirUnCZQe65w82p8z3tEgUMeta } from "/app/pages/company/announcements/index.vue?macro=true";
import { default as index33C0BHjNv3AVBEf8SsiODNY5H0akA8g4JkIRACDutG4Meta } from "/app/pages/company/benefit-funds/index.vue?macro=true";
import { default as loansJHov9nE2FnG3cAORBljLr3uyAlahzPo1PZwkymuBxmIMeta } from "/app/pages/company/benefit-funds/loans.vue?macro=true";
import { default as dashboardWUZqw_N7rcFIjv7tY1Mye1644_45P5QA_jQUn0jBS34UsMeta } from "/app/pages/company/workspace/dashboard.vue?macro=true";
import { default as membersnh_454Oo79ozzXd_45wyo_LLyN1sdbilQlnmtLE8ygmIlhgMeta } from "/app/pages/panel/benefit-funds/members.vue?macro=true";
import { default as indexmTtXlip7KMUW4WvkMEhc2PlBSmVLRmwFo_HCgzwUVdgMeta } from "/app/pages/panel/payrolls/[type]/index.vue?macro=true";
import { default as dashboardMZYfKjkcrZ8foTNSaBwEj7KYwV8ynkg_45iOUl7CcchfYMeta } from "/app/pages/panel/recruitment/dashboard.vue?macro=true";
import { default as _91page_93oAYhPQ23KR6BjRNlKSKIAkag0O62GSaGs7p4ajg4s3cMeta } from "/app/pages/company/projects/page/[page].vue?macro=true";
import { default as requests3UQGjSnogydMbrh_7i3fIDxNThh3iOCuug8rbIHRzhkMeta } from "/app/pages/panel/benefit-funds/requests.vue?macro=true";
import { default as settingsSDbwdgRTGTMHdvMw4ljnZqsPZ9EM6gmNAm_UvwJERUYMeta } from "/app/pages/panel/benefit-funds/settings.vue?macro=true";
import { default as indexxrNfqBvz9dSqFWaC7DH8KCvHb7Ud259gMIAP0uf6r1cMeta } from "/app/pages/panel/careers/requests/index.vue?macro=true";
import { default as index1juARi7R6YxGSmPRLXUhpu5vWi1HsBgmxNE_Pw2r9EsMeta } from "/app/pages/panel/projects/private/index.vue?macro=true";
import { default as _91page_93_rpvUdUTV2zazrPBTkaAR9WiEDr8fjyN2Cl5MfUz3TwMeta } from "/app/pages/admin/dev-tickets/page/[page].vue?macro=true";
import { default as indexFD3naeVnc5F1d1TNYzIzvbgpIry24ZMSQyBigLzXkycMeta } from "/app/pages/company/payrolls/[type]/index.vue?macro=true";
import { default as _91page_93enovFfd0dqxQHyL_oWbqcD8pE3PZfE9_v_hrTz6l9N4Meta } from "/app/pages/panel/attendances/page/[page].vue?macro=true";
import { default as lotteries6nn9Wy35ubUUPR2qEG2HygGAjjQcRHn1CxLB5GNkVBMMeta } from "/app/pages/panel/benefit-funds/lotteries.vue?macro=true";
import { default as dashboardHV7spj9c_lL_455r1MaRCJ571x8hp1SmRwnbbtQ9nh9jMMeta } from "/app/pages/panel/communication/dashboard.vue?macro=true";
import { default as _91page_938SL3BblJwTQLbNQu0xgpzAh3aJ__45LsNj1yfp_45u7NZoYMeta } from "/app/pages/panel/dev-tickets/page/[page].vue?macro=true";
import { default as dashboardMo8SaJpVAqwgXHPdciZOAJtHCGA2aksScyF33rkKz0EMeta } from "/app/pages/panel/administration/dashboard.vue?macro=true";
import { default as indexyfesNUWHxdytOxCAHaHZvjnvUNFDaxlGV5nnaeGZAbgMeta } from "/app/pages/panel/careers/onboarding/index.vue?macro=true";
import { default as _91page_93jW3PQz6ZGPVBaqPpoL_zoFeOB6_45ERhuorrbgUv9qQEYMeta } from "/app/pages/panel/custom-pages/page/[page].vue?macro=true";
import { default as index6PwkCZ1HhuhsWtu_0UjfjcvAHxE0nKje72h4DflL1s0Meta } from "/app/pages/panel/disciplinary-notes/index.vue?macro=true";
import { default as lotteriesUrv_45f0TASu0sbPF7aMYPlf2arJXNQyfSnvgTCI0lmtIMeta } from "/app/pages/company/benefit-funds/lotteries.vue?macro=true";
import { default as dashboardivLQFDX01_7OF27tuNw5Ro0P9mN8VTvbfxocnl7mQscMeta } from "/app/pages/company/communication/dashboard.vue?macro=true";
import { default as _91page_93k2LaQSMl9MQ09AXyDXpyXVZxciH6DwmdQP_xUpRCuZMMeta } from "/app/pages/panel/announcements/page/[page].vue?macro=true";
import { default as reviewD9t4Lh8evNOcEbdyXdelnwys9fv0KkfkZkhD2r95IWAMeta } from "/app/pages/panel/disciplinary-notes/review.vue?macro=true";
import { default as dashboardoSUAzADF3ps_45TbD6t_45kq4DXy5nVcVXpnZZBg_3VttDoMeta } from "/app/pages/panel/time-attendance/dashboard.vue?macro=true";
import { default as indexRkIFkEYcqcRy5ke_45LbpgMu5_Jzpi7DIJYCa2DPQH_45rwMeta } from "/app/pages/blog/category/[categoryId]/index.vue?macro=true";
import { default as indexHmivqOecrqBahpF93ZToJRe3e_7u4W_45rJOS4Ga8EjucMeta } from "/app/pages/blog/keyword-[keywordSlug]/index.vue?macro=true";
import { default as dashboard_45KPOLPKMj0e5cgBtgcw3eeTQtXMAH_3Cr3uouH_45EUfsMeta } from "/app/pages/company/administration/dashboard.vue?macro=true";
import { default as indexbISUSvvX9zwO8LSKF3FPiv8aPY9cucaQBqsvBoHGvdMMeta } from "/app/pages/company/disciplinary-notes/index.vue?macro=true";
import { default as indexvQHkZCeMEzzxiQz6QAetKGtL7aSnCbDMggxgyJmnQ_4Meta } from "/app/pages/help/category/[categoryId]/index.vue?macro=true";
import { default as index1nVWwHzGe6s06puLlY_459ZGk4A41CxoRcVeNI5_4562Ch8Meta } from "/app/pages/help/keyword-[keywordSlug]/index.vue?macro=true";
import { default as tasksDjWyIevYkaP8HEzJUtlRt3ZzYXCuJZkcENyz0LvSbmQMeta } from "/app/pages/panel/projects/[projectId]/tasks.vue?macro=true";
import { default as indexyZKPo0oyJf3jY4UnLY_45WZKEinjEtZwPDKAiK02_9V5oMeta } from "/app/pages/panel/projects/invitations/index.vue?macro=true";
import { default as index1bK5P7CyLVUHFGvzMp0qPmBxNWRhGk7NXBoEdzhVcf4Meta } from "/app/pages/company/[companyId]/careers/index.vue?macro=true";
import { default as dashboardA4NtV_453PAL_45_45Qq9Rf54UxxMdqPkp8I6uZ9xd6GxROOYMeta } from "/app/pages/company/time-attendance/dashboard.vue?macro=true";
import { default as _91customPageId_93YK_FjxeKDEpDb7flUo7BWt5lip663YgYdiUaXSeat74Meta } from "/app/pages/panel/custom-pages/[customPageId].vue?macro=true";
import { default as _91userId_93KiGdCxIdAFRtG5hkMsXsCRXpr5wuVdMXFehiJvOEdeIMeta } from "/app/pages/panel/disciplinary-notes/[userId].vue?macro=true";
import { default as _91page_93so0vYV1YiqnxkyDl8OOxDwgv1_45EDllTv8ofUwsbqm6AMeta } from "/app/pages/panel/payrolls/[type]/page/[page].vue?macro=true";
import { default as tasksnypgXO7TMP0T_TmVO8kdadin7JUKx1yjNhzBJWRLTDEMeta } from "/app/pages/company/projects/[projectId]/tasks.vue?macro=true";
import { default as indexymVMPE23L3as0Q_Hi7q2yG_Q0XrVY8n6Zi7g1nbxn5UMeta } from "/app/pages/company/projects/invitations/index.vue?macro=true";
import { default as _91page_93tKRKT2Z994DbMCD7KRXB9NmHiNaoyOkJAcFj8dpVywwMeta } from "/app/pages/panel/careers/requests/page/[page].vue?macro=true";
import { default as indexnSNXggUPdnU10sBrVhKfmYtQuuplRpfb7f2ZCz9tRBkMeta } from "/app/pages/panel/payrolls/[type]/groups/index.vue?macro=true";
import { default as _91page_933eaXT_cXW869wPkLR7jOIkSrAtiuMDj3UwMxCmPUVHsMeta } from "/app/pages/panel/projects/private/page/[page].vue?macro=true";
import { default as _91customPageId_93OoqFNinc5_45AwvswAONN3Hol9GRDB4dCl0_45Wwic1oAdoMeta } from "/app/pages/company/custom-pages/[customPageId].vue?macro=true";
import { default as _91page_93SXkOV5qt6xkaAX9nBofKyCYdmWjg65uAZs1IARcSf5oMeta } from "/app/pages/company/payrolls/[type]/page/[page].vue?macro=true";
import { default as categoriesQVOXPaNiqFueHPvbfAwaY53S_45FsQPwY_L3FdGsFBEfEMeta } from "/app/pages/panel/disciplinary-notes/categories.vue?macro=true";
import { default as dashboardCdwWlRG1bX57Mp8TEjeXLVtPP83JFPBo5WoFDVIOnZwMeta } from "/app/pages/panel/performance-reviews/dashboard.vue?macro=true";
import { default as _91page_939lquy1ovm2mzZ1rT6qMd5RpDZk9QRJ2aXj9XOCHB_45gQMeta } from "/app/pages/panel/careers/onboarding/page/[page].vue?macro=true";
import { default as _91page_93AEiLvJRBd_450SXcKwFgXwKZFJD1LLQVBf_452yXdh8hjOUMeta } from "/app/pages/panel/disciplinary-notes/page/[page].vue?macro=true";
import { default as columns9QfN0p8kMyRUKk2S4f7pQL4a2cIr3ptlK4Q_45PxlJIDYMeta } from "/app/pages/panel/payrolls/[type]/groups/columns.vue?macro=true";
import { default as dashboardFNTL6K52xspDvURZqRvrLCwrAux80iawk4VIN0erL5MMeta } from "/app/pages/company/performance-reviews/dashboard.vue?macro=true";
import { default as _91page_93zCmLGNJ28r99QTNsWp_45Sp2D2ljHVN3I_45BYKBhmmiY_MMeta } from "/app/pages/blog/category/[categoryId]/page/[page].vue?macro=true";
import { default as _91page_93d7fQ73dKNcUMWWivqfJkeDq4AFYN22Dh4GEtN_45_BNLkMeta } from "/app/pages/blog/keyword-[keywordSlug]/page/[page].vue?macro=true";
import { default as _91careerId_938DOUq4k9ViBYpu5g_iofIy3B5ip_axtXPDJz8Qnnj4UMeta } from "/app/pages/company/[companyId]/careers/[careerId].vue?macro=true";
import { default as _91page_931H4h0DR1cBjjVGrMQROZgjYDSYEIGRqHtpA1HWrRubwMeta } from "/app/pages/help/category/[categoryId]/page/[page].vue?macro=true";
import { default as _91page_93Cl5XExRUmY7_458KBkEzIGP6ubZojO9k0EYWiJYRu5nuwMeta } from "/app/pages/help/keyword-[keywordSlug]/page/[page].vue?macro=true";
import { default as indexL_458Qhb4Tlr5fYZ_45c2Enejv2oVhmRW40rRh_45WVPBnEsMMeta } from "/app/pages/panel/performance-reviews/[type]/index.vue?macro=true";
import { default as _91page_93DdbyNTkqJJOXMUdXgSF7RQSbHnMZjYpLk6_RDAplM4sMeta } from "/app/pages/panel/projects/invitations/page/[page].vue?macro=true";
import { default as _91scheduleId_93B2MtzCSX9TqcFXJncWVLKOpugV00ebIx59uqaa0Wo94Meta } from "/app/pages/panel/kitchen/reservations/[scheduleId].vue?macro=true";
import { default as indexQQo0EGv_YtsTQr19tbZF2lFX5rnoX55P_dEHEFrkCToMeta } from "/app/pages/company/performance-reviews/[type]/index.vue?macro=true";
import { default as _91page_93F91sFHqUscdNssUTmH1stWoUPMSIf99KxXUKlCD0q6YMeta } from "/app/pages/company/projects/invitations/page/[page].vue?macro=true";
import { default as _91page_93RV9bwnVjrhX50EJoypQv13bR301QP7_Oc93AMDNc0s0Meta } from "/app/pages/panel/payrolls/[type]/groups/page/[page].vue?macro=true";
import { default as survey_45_91companyId_93_45_91surveyId_93_45_91secretCode_932yPqTslTeCXXU1diE7X35azsRU_xGGWbJPJx0Qz8D74Meta } from "/app/pages/survey-[companyId]-[surveyId]-[secretCode].vue?macro=true";
import { default as _91page_93DD5Y8HiciA4vHcz6_45mopbOsMBr5b_DLmlv0oLKc7f5kMeta } from "/app/pages/panel/performance-reviews/[type]/page/[page].vue?macro=true";
import { default as indexE6f_stIfJZ7nAZFi1o2SaH1oz3_Xm3ftczUSm8KmnyAMeta } from "/app/pages/panel/performance-reviews/[type]/groups/index.vue?macro=true";
import { default as _91page_93jz6pY0RTsKMHNJAWrATSOv2asXIT3ooRdnahH38hUAUMeta } from "/app/pages/company/performance-reviews/[type]/page/[page].vue?macro=true";
import { default as columnsjZu4Lkvq4WraGTcNV0fQhqFE3YbN_radZ75ZEfBgdGsMeta } from "/app/pages/panel/performance-reviews/[type]/groups/columns.vue?macro=true";
import { default as _91page_93XdSkEBgvwhOlateQPlTcW7fIGbvjmABVfxb_9zO_457oAMeta } from "/app/pages/panel/performance-reviews/[type]/groups/page/[page].vue?macro=true";
export default [
  {
    name: "auth",
    path: "/auth",
    meta: {"middleware":["noauth","payroll-module-domain-lock","career-module-domain-lock","career-module-domain-lock"]},
    component: () => import("/app/pages/auth.vue")
  },
  {
    name: "index",
    path: "/",
    meta: {"middleware":["payroll-module-domain-lock","career-module-domain-lock"]},
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "rules",
    path: "/rules",
    component: () => import("/app/pages/rules.vue")
  },
  {
    name: "offline",
    path: "/offline",
    component: () => import("/app/pages/offline.vue")
  },
  {
    name: "about-us",
    path: "/about-us",
    component: () => import("/app/pages/about-us.vue")
  },
  {
    name: "blog",
    path: "/blog",
    component: () => import("/app/pages/blog/index.vue")
  },
  {
    name: "contact-us",
    path: "/contact-us",
    component: () => import("/app/pages/contact-us.vue")
  },
  {
    name: "help",
    path: "/help",
    component: () => import("/app/pages/help/index.vue")
  },
  {
    name: "admin",
    path: "/admin",
    meta: {"middleware":["admin-panel-auth","payroll-module-domain-lock","career-module-domain-lock"]},
    component: () => import("/app/pages/admin/index.vue")
  },
  {
    name: "admin-login",
    path: "/admin/login",
    meta: {"middleware":["admin-panel-noauth","payroll-module-domain-lock","career-module-domain-lock"]},
    component: () => import("/app/pages/admin/login.vue")
  },
  {
    name: "company-inbox",
    path: "/company/inbox",
    meta: {"middleware":["company-panel-auth"]},
    component: () => import("/app/pages/company/inbox.vue")
  },
  {
    name: "company",
    path: "/company",
    meta: {"middleware":["company-panel-auth"]},
    component: () => import("/app/pages/company/index.vue")
  },
  {
    name: "panel-settings",
    path: "/panel/settings",
    meta: {"middleware":["panel-auth"]},
    component: () => import("/app/pages/panel/settings.vue")
  },
  {
    name: "panel-cms",
    path: "/panel/cms",
    meta: {"middleware":["panel-auth","company"]},
    component: () => import("/app/pages/panel/cms/index.vue")
  },
  {
    name: "panel-crm",
    path: "/panel/crm",
    meta: {"middleware":["panel-auth","company"]},
    component: () => import("/app/pages/panel/crm/index.vue")
  },
  {
    name: "panel-dashboard",
    path: "/panel/dashboard",
    meta: {"middleware":["panel-auth"]},
    component: () => import("/app/pages/panel/dashboard.vue")
  },
  {
    name: "admin-logs",
    path: "/admin/logs",
    meta: {"middleware":["admin-auth"]},
    component: () => import("/app/pages/admin/logs/index.vue")
  },
  {
    name: "blog-page-page",
    path: "/blog/page/:page()",
    component: () => import("/app/pages/blog/page/[page].vue")
  },
  {
    name: "company-settings",
    path: "/company/settings",
    meta: {"middleware":["company-panel-auth"]},
    component: () => import("/app/pages/company/settings.vue")
  },
  {
    name: "help-page-page",
    path: "/help/page/:page()",
    component: () => import("/app/pages/help/page/[page].vue")
  },
  {
    name: "panel-chat",
    path: "/panel/chat",
    meta: {"middleware":["panel-auth","company"]},
    component: () => import("/app/pages/panel/chat/index.vue")
  },
  {
    name: "panel-vira",
    path: "/panel/vira",
    meta: {"middleware":["panel-auth","company"]},
    component: () => import("/app/pages/panel/vira/index.vue")
  },
  {
    name: "admin-metas",
    path: "/admin/metas",
    meta: {"middleware":["admin-auth"]},
    component: () => import("/app/pages/admin/metas/index.vue")
  },
  {
    name: "admin-posts",
    path: "/admin/posts",
    meta: {"middleware":["blogger-auth"]},
    component: () => import("/app/pages/admin/posts/index.vue")
  },
  {
    name: "admin-rules",
    path: "/admin/rules",
    meta: {"middleware":["blogger-auth"]},
    component: () => import("/app/pages/admin/rules/index.vue")
  },
  {
    name: "admin-users",
    path: "/admin/users",
    meta: {"middleware":["admin-auth"]},
    component: () => import("/app/pages/admin/users/index.vue")
  },
  {
    name: "panel-mails",
    path: "/panel/mails",
    meta: {"middleware":["panel-auth","company"]},
    component: () => import("/app/pages/panel/mails/index.vue")
  },
  {
    name: "panel-roles",
    path: "/panel/roles",
    meta: {"middleware":["panel-auth","company"]},
    component: () => import("/app/pages/panel/roles/index.vue")
  },
  {
    name: "panel-users",
    path: "/panel/users",
    meta: {"middleware":["panel-auth","company"]},
    component: () => import("/app/pages/panel/users/index.vue")
  },
  {
    name: "admin-posts-create",
    path: "/admin/posts/create",
    meta: {"middleware":["blogger-auth"]},
    component: () => import("/app/pages/admin/posts/create.vue")
  },
  {
    name: "admin-slides",
    path: "/admin/slides",
    meta: {"middleware":["blogger-auth"]},
    component: () => import("/app/pages/admin/slides/index.vue")
  },
  {
    name: "company-chat",
    path: "/company/chat",
    meta: {"middleware":["company-panel-auth"]},
    component: () => import("/app/pages/company/chat/index.vue")
  },
  {
    name: "company-mails",
    path: "/company/mails",
    meta: {"middleware":["company-panel-auth"]},
    component: () => import("/app/pages/company/mails/index.vue")
  },
  {
    name: "company-tasks",
    path: "/company/tasks",
    meta: {"middleware":["company-panel-auth"]},
    component: () => import("/app/pages/company/tasks/index.vue")
  },
  {
    name: "panel-careers",
    path: "/panel/careers",
    meta: {"middleware":["panel-auth","company"]},
    component: () => import("/app/pages/panel/careers/index.vue")
  },
  {
    name: "panel-cms-dashboard",
    path: "/panel/cms/dashboard",
    component: () => import("/app/pages/panel/cms/dashboard.vue")
  },
  {
    name: "panel-kitchen-foods",
    path: "/panel/kitchen/foods",
    meta: {"middleware":["panel-auth","company"]},
    component: () => import("/app/pages/panel/kitchen/foods.vue")
  },
  {
    name: "panel-kitchen",
    path: "/panel/kitchen",
    meta: {"middleware":["panel-auth","company"]},
    component: () => import("/app/pages/panel/kitchen/index.vue")
  },
  {
    name: "panel-surveys",
    path: "/panel/surveys",
    meta: {"middleware":["panel-auth","company"]},
    component: () => import("/app/pages/panel/surveys/index.vue")
  },
  {
    name: "admin-about-us",
    path: "/admin/about-us",
    meta: {"middleware":["blogger-auth"]},
    component: () => import("/app/pages/admin/about-us/index.vue")
  },
  {
    name: "admin-posts-postId",
    path: "/admin/posts/:postId()",
    meta: {"middleware":["blogger-auth"]},
    component: () => import("/app/pages/admin/posts/[postId].vue")
  },
  {
    name: "help-single-postId",
    path: "/help/single/:postId()",
    component: () => import("/app/pages/help/single/[postId].vue")
  },
  {
    name: "panel-contacts",
    path: "/panel/contacts",
    component: () => import("/app/pages/panel/contacts/index.vue")
  },
  {
    name: "panel-mails-noteId",
    path: "/panel/mails/:noteId()",
    meta: {"middleware":["panel-auth","company"]},
    component: () => import("/app/pages/panel/mails/[noteId].vue")
  },
  {
    name: "panel-projects",
    path: "/panel/projects",
    meta: {"middleware":["panel-auth","company"]},
    component: () => import("/app/pages/panel/projects/index.vue")
  },
  {
    name: "panel-users-userId",
    path: "/panel/users/:userId()",
    meta: {"middleware":["panel-auth","company"]},
    component: () => import("/app/pages/panel/users/[userId].vue")
  },
  {
    name: "admin-companies",
    path: "/admin/companies",
    meta: {"middleware":["admin-auth"]},
    component: () => import("/app/pages/admin/companies/index.vue")
  },
  {
    name: "company-surveys",
    path: "/company/surveys",
    meta: {"middleware":["company-panel-auth"]},
    component: () => import("/app/pages/company/surveys/index.vue")
  },
  {
    name: "panel-cms-forms",
    path: "/panel/cms/forms",
    meta: {"middleware":["panel-auth","company"]},
    component: () => import("/app/pages/panel/cms/forms/index.vue")
  },
  {
    name: "admin-categories",
    path: "/admin/categories",
    meta: {"middleware":["blogger-auth"]},
    component: () => import("/app/pages/admin/categories/index.vue")
  },
  {
    name: "admin-contact-us",
    path: "/admin/contact-us",
    meta: {"middleware":["blogger-auth"]},
    component: () => import("/app/pages/admin/contact-us/index.vue")
  },
  {
    name: "admin-logs-page-page",
    path: "/admin/logs/page/:page()",
    meta: _91page_932AwH4dp1yyyCdBqH6I86C4GAt3gWfaph1sVod8sZptsMeta || {},
    component: () => import("/app/pages/admin/logs/page/[page].vue")
  },
  {
    name: "company-mails-noteId",
    path: "/company/mails/:noteId()",
    meta: {"middleware":["company-panel-auth"]},
    component: () => import("/app/pages/company/mails/[noteId].vue")
  },
  {
    name: "company-projects",
    path: "/company/projects",
    meta: {"middleware":["company-panel-auth"]},
    component: () => import("/app/pages/company/projects/index.vue")
  },
  {
    name: "panel-categories",
    path: "/panel/categories",
    meta: {"middleware":["panel-auth","company"]},
    component: () => import("/app/pages/panel/categories/index.vue")
  },
  {
    name: "panel-cms-posts-create",
    path: "/panel/cms/posts/create",
    meta: {"middleware":["panel-auth","company"]},
    component: () => import("/app/pages/panel/cms/posts/create.vue")
  },
  {
    name: "panel-company-settings",
    path: "/panel/company-settings",
    meta: {"middleware":["panel-auth","company"]},
    component: () => import("/app/pages/panel/company-settings.vue")
  },
  {
    name: "panel-people-dashboard",
    path: "/panel/people/dashboard",
    component: () => import("/app/pages/panel/people/dashboard.vue")
  },
  {
    name: "admin-dev-tickets",
    path: "/admin/dev-tickets",
    meta: {"middleware":["auth"]},
    component: () => import("/app/pages/admin/dev-tickets/index.vue")
  },
  {
    name: "admin-posts-page-page",
    path: "/admin/posts/page/:page()",
    meta: {"middleware":["blogger-auth"]},
    component: () => import("/app/pages/admin/posts/page/[page].vue")
  },
  {
    name: "admin-users-page-page",
    path: "/admin/users/page/:page()",
    component: () => import("/app/pages/admin/users/page/[page].vue")
  },
  {
    name: "blog-single-articleId",
    path: "/blog/single/:articleId()",
    component: () => import("/app/pages/blog/single/[articleId].vue")
  },
  {
    name: "panel-attendances",
    path: "/panel/attendances",
    meta: {"middleware":["panel-auth","company"]},
    component: () => import("/app/pages/panel/attendances/index.vue")
  },
  {
    name: "panel-dev-tickets",
    path: "/panel/dev-tickets",
    meta: {"middleware":["auth"]},
    component: () => import("/app/pages/panel/dev-tickets/index.vue")
  },
  {
    name: "panel-mails-page-page",
    path: "/panel/mails/page/:page()",
    meta: {"middleware":["panel-auth","company"]},
    component: () => import("/app/pages/panel/mails/page/[page].vue")
  },
  {
    name: "panel-users-page-page",
    path: "/panel/users/page/:page()",
    meta: {"middleware":["panel-auth","company"]},
    component: () => import("/app/pages/panel/users/page/[page].vue")
  },
  {
    name: "company-companyId-auth",
    path: "/company/:companyId()/auth",
    meta: {"middleware":["company-panel-noauth"]},
    component: () => import("/app/pages/company/[companyId]/auth.vue")
  },
  {
    name: "panel-careers-categories",
    path: "/panel/careers/categories",
    meta: {"middleware":["panel-auth","company"]},
    component: () => import("/app/pages/panel/careers/categories.vue")
  },
  {
    name: "panel-cms-forms-formId",
    path: "/panel/cms/forms/:formId()",
    meta: {"middleware":["panel-auth","company"]},
    component: () => import("/app/pages/panel/cms/forms/[formId].vue")
  },
  {
    name: "panel-cms-posts-postId",
    path: "/panel/cms/posts/:postId()",
    meta: {"middleware":["panel-auth","company"]},
    component: () => import("/app/pages/panel/cms/posts/[postId].vue")
  },
  {
    name: "panel-custom-pages",
    path: "/panel/custom-pages",
    meta: {"middleware":["panel-auth","company"]},
    component: () => import("/app/pages/panel/custom-pages/index.vue")
  },
  {
    name: "panel-organization-chart",
    path: "/panel/organization-chart",
    meta: {"middleware":["panel-auth","company"]},
    component: () => import("/app/pages/panel/organization-chart.vue")
  },
  {
    name: "panel-organization-units",
    path: "/panel/organization-units",
    meta: {"middleware":["panel-auth","company"]},
    component: () => import("/app/pages/panel/organization-units.vue")
  },
  {
    name: "panel-payrolls-dashboard",
    path: "/panel/payrolls/dashboard",
    component: () => import("/app/pages/panel/payrolls/dashboard.vue")
  },
  {
    name: "panel-surveys-surveyId",
    path: "/panel/surveys/:surveyId()",
    meta: {"middleware":["panel-auth","company"]},
    component: () => import("/app/pages/panel/surveys/[surveyId].vue")
  },
  {
    name: "company-attendances",
    path: "/company/attendances",
    meta: {"middleware":["company-panel-auth"]},
    component: () => import("/app/pages/company/attendances/index.vue")
  },
  {
    name: "company-mails-page-page",
    path: "/company/mails/page/:page()",
    meta: {"middleware":["company-panel-auth"]},
    component: () => import("/app/pages/company/mails/page/[page].vue")
  },
  {
    name: "company-tasks-page-page",
    path: "/company/tasks/page/:page()",
    meta: {"middleware":["company-panel-auth"]},
    component: () => import("/app/pages/company/tasks/page/[page].vue")
  },
  {
    name: "panel-announcements",
    path: "/panel/announcements",
    meta: {"middleware":["panel-auth","company"]},
    component: () => import("/app/pages/panel/announcements/index.vue")
  },
  {
    name: "panel-benefit-funds",
    path: "/panel/benefit-funds",
    meta: {"middleware":["panel-auth","company"]},
    component: () => import("/app/pages/panel/benefit-funds/index.vue")
  },
  {
    name: "panel-benefit-funds-loans",
    path: "/panel/benefit-funds/loans",
    meta: {"middleware":["panel-auth","company"]},
    component: () => import("/app/pages/panel/benefit-funds/loans.vue")
  },
  {
    name: "panel-projects-activities",
    path: "/panel/projects/activities",
    meta: {"middleware":["panel-auth","company"]},
    component: () => import("/app/pages/panel/projects/activities.vue")
  },
  {
    name: "panel-surveys-page-page",
    path: "/panel/surveys/page/:page()",
    meta: {"middleware":["panel-auth","company"]},
    component: () => import("/app/pages/panel/surveys/page/[page].vue")
  },
  {
    name: "panel-workspace-dashboard",
    path: "/panel/workspace/dashboard",
    component: () => import("/app/pages/panel/workspace/dashboard.vue")
  },
  {
    name: "company-payrolls-dashboard",
    path: "/company/payrolls/dashboard",
    component: () => import("/app/pages/company/payrolls/dashboard.vue")
  },
  {
    name: "company-reserve-food",
    path: "/company/reserve-food",
    meta: {"middleware":["company-panel-auth"]},
    component: () => import("/app/pages/company/reserve-food/index.vue")
  },
  {
    name: "company-workspace-overview",
    path: "/company/workspace/overview",
    meta: {"middleware":["company-panel-auth"]},
    component: () => import("/app/pages/company/workspace/overview.vue")
  },
  {
    name: "panel-attendances-userId",
    path: "/panel/attendances/:userId()",
    meta: {"middleware":["panel-auth","company"]},
    component: () => import("/app/pages/panel/attendances/[userId].vue")
  },
  {
    name: "panel-contacts-page-page",
    path: "/panel/contacts/page/:page()",
    meta: {"middleware":["panel-auth","company"]},
    component: () => import("/app/pages/panel/contacts/page/[page].vue")
  },
  {
    name: "panel-projects-page-page",
    path: "/panel/projects/page/:page()",
    meta: {"middleware":["panel-auth","company"]},
    component: () => import("/app/pages/panel/projects/page/[page].vue")
  },
  {
    name: "admin-companies-page-page",
    path: "/admin/companies/page/:page()",
    component: () => import("/app/pages/admin/companies/page/[page].vue")
  },
  {
    name: "company-announcements",
    path: "/company/announcements",
    meta: {"middleware":["company-panel-auth"]},
    component: () => import("/app/pages/company/announcements/index.vue")
  },
  {
    name: "company-benefit-funds",
    path: "/company/benefit-funds",
    meta: {"middleware":["company-panel-auth"]},
    component: () => import("/app/pages/company/benefit-funds/index.vue")
  },
  {
    name: "company-benefit-funds-loans",
    path: "/company/benefit-funds/loans",
    meta: {"middleware":["company-panel-auth"]},
    component: () => import("/app/pages/company/benefit-funds/loans.vue")
  },
  {
    name: "company-workspace-dashboard",
    path: "/company/workspace/dashboard",
    component: () => import("/app/pages/company/workspace/dashboard.vue")
  },
  {
    name: "panel-benefit-funds-members",
    path: "/panel/benefit-funds/members",
    meta: {"middleware":["panel-auth","company"]},
    component: () => import("/app/pages/panel/benefit-funds/members.vue")
  },
  {
    name: "panel-payrolls-type",
    path: "/panel/payrolls/:type()",
    meta: {"middleware":["panel-auth","company"]},
    component: () => import("/app/pages/panel/payrolls/[type]/index.vue")
  },
  {
    name: "panel-recruitment-dashboard",
    path: "/panel/recruitment/dashboard",
    component: () => import("/app/pages/panel/recruitment/dashboard.vue")
  },
  {
    name: "company-projects-page-page",
    path: "/company/projects/page/:page()",
    meta: {"middleware":["company-panel-auth"]},
    component: () => import("/app/pages/company/projects/page/[page].vue")
  },
  {
    name: "panel-benefit-funds-requests",
    path: "/panel/benefit-funds/requests",
    meta: {"middleware":["panel-auth","company"]},
    component: () => import("/app/pages/panel/benefit-funds/requests.vue")
  },
  {
    name: "panel-benefit-funds-settings",
    path: "/panel/benefit-funds/settings",
    meta: {"middleware":["panel-auth","company"]},
    component: () => import("/app/pages/panel/benefit-funds/settings.vue")
  },
  {
    name: "panel-careers-requests",
    path: "/panel/careers/requests",
    meta: {"middleware":["panel-auth","company"]},
    component: () => import("/app/pages/panel/careers/requests/index.vue")
  },
  {
    name: "panel-projects-private",
    path: "/panel/projects/private",
    meta: {"middleware":["panel-auth","company"]},
    component: () => import("/app/pages/panel/projects/private/index.vue")
  },
  {
    name: "admin-dev-tickets-page-page",
    path: "/admin/dev-tickets/page/:page()",
    meta: _91page_93_rpvUdUTV2zazrPBTkaAR9WiEDr8fjyN2Cl5MfUz3TwMeta || {},
    component: () => import("/app/pages/admin/dev-tickets/page/[page].vue")
  },
  {
    name: "company-payrolls-type",
    path: "/company/payrolls/:type()",
    meta: {"middleware":["company-panel-auth"]},
    component: () => import("/app/pages/company/payrolls/[type]/index.vue")
  },
  {
    name: "panel-attendances-page-page",
    path: "/panel/attendances/page/:page()",
    meta: {"middleware":["panel-auth","company"]},
    component: () => import("/app/pages/panel/attendances/page/[page].vue")
  },
  {
    name: "panel-benefit-funds-lotteries",
    path: "/panel/benefit-funds/lotteries",
    meta: {"middleware":["panel-auth","company"]},
    component: () => import("/app/pages/panel/benefit-funds/lotteries.vue")
  },
  {
    name: "panel-communication-dashboard",
    path: "/panel/communication/dashboard",
    component: () => import("/app/pages/panel/communication/dashboard.vue")
  },
  {
    name: "panel-dev-tickets-page-page",
    path: "/panel/dev-tickets/page/:page()",
    meta: {"middleware":["auth"]},
    component: () => import("/app/pages/panel/dev-tickets/page/[page].vue")
  },
  {
    name: "panel-administration-dashboard",
    path: "/panel/administration/dashboard",
    component: () => import("/app/pages/panel/administration/dashboard.vue")
  },
  {
    name: "panel-careers-onboarding",
    path: "/panel/careers/onboarding",
    meta: {"middleware":["panel-auth","company"]},
    component: () => import("/app/pages/panel/careers/onboarding/index.vue")
  },
  {
    name: "panel-custom-pages-page-page",
    path: "/panel/custom-pages/page/:page()",
    meta: {"middleware":["panel-auth","company"]},
    component: () => import("/app/pages/panel/custom-pages/page/[page].vue")
  },
  {
    name: "panel-disciplinary-notes",
    path: "/panel/disciplinary-notes",
    meta: {"middleware":["panel-auth","company"]},
    component: () => import("/app/pages/panel/disciplinary-notes/index.vue")
  },
  {
    name: "company-benefit-funds-lotteries",
    path: "/company/benefit-funds/lotteries",
    meta: {"middleware":["company-panel-auth"]},
    component: () => import("/app/pages/company/benefit-funds/lotteries.vue")
  },
  {
    name: "company-communication-dashboard",
    path: "/company/communication/dashboard",
    component: () => import("/app/pages/company/communication/dashboard.vue")
  },
  {
    name: "panel-announcements-page-page",
    path: "/panel/announcements/page/:page()",
    meta: {"middleware":["panel-auth","company"]},
    component: () => import("/app/pages/panel/announcements/page/[page].vue")
  },
  {
    name: "panel-disciplinary-notes-review",
    path: "/panel/disciplinary-notes/review",
    meta: {"middleware":["panel-auth","company"]},
    component: () => import("/app/pages/panel/disciplinary-notes/review.vue")
  },
  {
    name: "panel-time-attendance-dashboard",
    path: "/panel/time-attendance/dashboard",
    component: () => import("/app/pages/panel/time-attendance/dashboard.vue")
  },
  {
    name: "blog-category-categoryId",
    path: "/blog/category/:categoryId()",
    component: () => import("/app/pages/blog/category/[categoryId]/index.vue")
  },
  {
    name: "blog-keyword-keywordSlug",
    path: "/blog/keyword-:keywordSlug()",
    component: () => import("/app/pages/blog/keyword-[keywordSlug]/index.vue")
  },
  {
    name: "company-administration-dashboard",
    path: "/company/administration/dashboard",
    component: () => import("/app/pages/company/administration/dashboard.vue")
  },
  {
    name: "company-disciplinary-notes",
    path: "/company/disciplinary-notes",
    meta: {"middleware":["company-panel-auth"]},
    component: () => import("/app/pages/company/disciplinary-notes/index.vue")
  },
  {
    name: "help-category-categoryId",
    path: "/help/category/:categoryId()",
    component: () => import("/app/pages/help/category/[categoryId]/index.vue")
  },
  {
    name: "help-keyword-keywordSlug",
    path: "/help/keyword-:keywordSlug()",
    component: () => import("/app/pages/help/keyword-[keywordSlug]/index.vue")
  },
  {
    name: "panel-projects-projectId-tasks",
    path: "/panel/projects/:projectId()/tasks",
    meta: {"middleware":["panel-auth","company"]},
    component: () => import("/app/pages/panel/projects/[projectId]/tasks.vue")
  },
  {
    name: "panel-projects-invitations",
    path: "/panel/projects/invitations",
    meta: {"middleware":["panel-auth","company"]},
    component: () => import("/app/pages/panel/projects/invitations/index.vue")
  },
  {
    name: "company-companyId-careers",
    path: "/company/:companyId()/careers",
    component: () => import("/app/pages/company/[companyId]/careers/index.vue")
  },
  {
    name: "company-time-attendance-dashboard",
    path: "/company/time-attendance/dashboard",
    component: () => import("/app/pages/company/time-attendance/dashboard.vue")
  },
  {
    name: "panel-custom-pages-customPageId",
    path: "/panel/custom-pages/:customPageId()",
    meta: {"middleware":["panel-auth","company"]},
    component: () => import("/app/pages/panel/custom-pages/[customPageId].vue")
  },
  {
    name: "panel-disciplinary-notes-userId",
    path: "/panel/disciplinary-notes/:userId()",
    meta: {"middleware":["panel-auth","company"]},
    component: () => import("/app/pages/panel/disciplinary-notes/[userId].vue")
  },
  {
    name: "panel-payrolls-type-page-page",
    path: "/panel/payrolls/:type()/page/:page()",
    meta: {"middleware":["panel-auth","company"]},
    component: () => import("/app/pages/panel/payrolls/[type]/page/[page].vue")
  },
  {
    name: "company-projects-projectId-tasks",
    path: "/company/projects/:projectId()/tasks",
    meta: {"middleware":["company-panel-auth"]},
    component: () => import("/app/pages/company/projects/[projectId]/tasks.vue")
  },
  {
    name: "company-projects-invitations",
    path: "/company/projects/invitations",
    meta: {"middleware":["company-panel-auth"]},
    component: () => import("/app/pages/company/projects/invitations/index.vue")
  },
  {
    name: "panel-careers-requests-page-page",
    path: "/panel/careers/requests/page/:page()",
    meta: {"middleware":["panel-auth","company"]},
    component: () => import("/app/pages/panel/careers/requests/page/[page].vue")
  },
  {
    name: "panel-payrolls-type-groups",
    path: "/panel/payrolls/:type()/groups",
    meta: {"middleware":["panel-auth","company"]},
    component: () => import("/app/pages/panel/payrolls/[type]/groups/index.vue")
  },
  {
    name: "panel-projects-private-page-page",
    path: "/panel/projects/private/page/:page()",
    meta: {"middleware":["panel-auth","company"]},
    component: () => import("/app/pages/panel/projects/private/page/[page].vue")
  },
  {
    name: "company-custom-pages-customPageId",
    path: "/company/custom-pages/:customPageId()",
    meta: {"middleware":["company-panel-auth"]},
    component: () => import("/app/pages/company/custom-pages/[customPageId].vue")
  },
  {
    name: "company-payrolls-type-page-page",
    path: "/company/payrolls/:type()/page/:page()",
    meta: {"middleware":["company-panel-auth"]},
    component: () => import("/app/pages/company/payrolls/[type]/page/[page].vue")
  },
  {
    name: "panel-disciplinary-notes-categories",
    path: "/panel/disciplinary-notes/categories",
    meta: {"middleware":["panel-auth","company"]},
    component: () => import("/app/pages/panel/disciplinary-notes/categories.vue")
  },
  {
    name: "panel-performance-reviews-dashboard",
    path: "/panel/performance-reviews/dashboard",
    component: () => import("/app/pages/panel/performance-reviews/dashboard.vue")
  },
  {
    name: "panel-careers-onboarding-page-page",
    path: "/panel/careers/onboarding/page/:page()",
    meta: {"middleware":["panel-auth","company"]},
    component: () => import("/app/pages/panel/careers/onboarding/page/[page].vue")
  },
  {
    name: "panel-disciplinary-notes-page-page",
    path: "/panel/disciplinary-notes/page/:page()",
    meta: {"middleware":["panel-auth","company"]},
    component: () => import("/app/pages/panel/disciplinary-notes/page/[page].vue")
  },
  {
    name: "panel-payrolls-type-groups-columns",
    path: "/panel/payrolls/:type()/groups/columns",
    meta: {"middleware":["panel-auth","company"]},
    component: () => import("/app/pages/panel/payrolls/[type]/groups/columns.vue")
  },
  {
    name: "company-performance-reviews-dashboard",
    path: "/company/performance-reviews/dashboard",
    component: () => import("/app/pages/company/performance-reviews/dashboard.vue")
  },
  {
    name: "blog-category-categoryId-page-page",
    path: "/blog/category/:categoryId()/page/:page()",
    component: () => import("/app/pages/blog/category/[categoryId]/page/[page].vue")
  },
  {
    name: "blog-keyword-keywordSlug-page-page",
    path: "/blog/keyword-:keywordSlug()/page/:page()",
    component: () => import("/app/pages/blog/keyword-[keywordSlug]/page/[page].vue")
  },
  {
    name: "company-companyId-careers-careerId",
    path: "/company/:companyId()/careers/:careerId()",
    component: () => import("/app/pages/company/[companyId]/careers/[careerId].vue")
  },
  {
    name: "help-category-categoryId-page-page",
    path: "/help/category/:categoryId()/page/:page()",
    component: () => import("/app/pages/help/category/[categoryId]/page/[page].vue")
  },
  {
    name: "help-keyword-keywordSlug-page-page",
    path: "/help/keyword-:keywordSlug()/page/:page()",
    component: () => import("/app/pages/help/keyword-[keywordSlug]/page/[page].vue")
  },
  {
    name: "panel-performance-reviews-type",
    path: "/panel/performance-reviews/:type()",
    meta: {"middleware":["panel-auth","company"]},
    component: () => import("/app/pages/panel/performance-reviews/[type]/index.vue")
  },
  {
    name: "panel-projects-invitations-page-page",
    path: "/panel/projects/invitations/page/:page()",
    meta: {"middleware":["panel-auth","company"]},
    component: () => import("/app/pages/panel/projects/invitations/page/[page].vue")
  },
  {
    name: "panel-kitchen-reservations-scheduleId",
    path: "/panel/kitchen/reservations/:scheduleId()",
    meta: {"middleware":["panel-auth","company"]},
    component: () => import("/app/pages/panel/kitchen/reservations/[scheduleId].vue")
  },
  {
    name: "company-performance-reviews-type",
    path: "/company/performance-reviews/:type()",
    meta: {"middleware":["company-panel-auth"]},
    component: () => import("/app/pages/company/performance-reviews/[type]/index.vue")
  },
  {
    name: "company-projects-invitations-page-page",
    path: "/company/projects/invitations/page/:page()",
    meta: {"middleware":["company-panel-auth"]},
    component: () => import("/app/pages/company/projects/invitations/page/[page].vue")
  },
  {
    name: "panel-payrolls-type-groups-page-page",
    path: "/panel/payrolls/:type()/groups/page/:page()",
    meta: {"middleware":["panel-auth","company"]},
    component: () => import("/app/pages/panel/payrolls/[type]/groups/page/[page].vue")
  },
  {
    name: "survey-companyId-surveyId-secretCode",
    path: "/survey-:companyId()-:surveyId()-:secretCode()",
    component: () => import("/app/pages/survey-[companyId]-[surveyId]-[secretCode].vue")
  },
  {
    name: "panel-performance-reviews-type-page-page",
    path: "/panel/performance-reviews/:type()/page/:page()",
    meta: {"middleware":["panel-auth","company"]},
    component: () => import("/app/pages/panel/performance-reviews/[type]/page/[page].vue")
  },
  {
    name: "panel-performance-reviews-type-groups",
    path: "/panel/performance-reviews/:type()/groups",
    meta: {"middleware":["panel-auth","company"]},
    component: () => import("/app/pages/panel/performance-reviews/[type]/groups/index.vue")
  },
  {
    name: "company-performance-reviews-type-page-page",
    path: "/company/performance-reviews/:type()/page/:page()",
    meta: {"middleware":["company-panel-auth"]},
    component: () => import("/app/pages/company/performance-reviews/[type]/page/[page].vue")
  },
  {
    name: "panel-performance-reviews-type-groups-columns",
    path: "/panel/performance-reviews/:type()/groups/columns",
    meta: {"middleware":["panel-auth","company"]},
    component: () => import("/app/pages/panel/performance-reviews/[type]/groups/columns.vue")
  },
  {
    name: "panel-performance-reviews-type-groups-page-page",
    path: "/panel/performance-reviews/:type()/groups/page/:page()",
    meta: {"middleware":["panel-auth","company"]},
    component: () => import("/app/pages/panel/performance-reviews/[type]/groups/page/[page].vue")
  }
]